<template>
  <div>
    <v-container :class="ui.bkgdColor">
      <v-layout row>
        <v-spacer/>
        <v-btn :color="ui.btnColor" @click="changeAdmin()" flat
          v-if="btnSpinChangeAdmin === false"
          :disabled="this.getDataSavePendingIndication === false">
          <v-icon left> cloud </v-icon>
          Upload
        </v-btn>
        <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinChangeAdmin === true"/>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import changeAdmin from "@/support/detail/mixins/changeAdmin.js";
// import GetDetailPage from "@/support/detail/components/GetDetailPage";

export default {
  data() {
    return {
      valid: true,
      btnSpinChangeAdmin: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      }
    };
  },
  props: {
    data: {
      type: Object
    }
  },
  mixins: [apptheme, changeAdmin, licenceFunctions, adminFunctions],
  components: {
    BtnSpin
    // GetDetailPage
  },
  computed: {
    ...mapGetters(["getCurrentPage", "getDataSavePendingIndication"])
  }
};
</script>
